// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav"};